import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'src/app/services/notification.service';
import { finalize } from 'rxjs';
import { helper } from 'src/environments/helper';
import { SlotBlocare } from '../../program.interface';
import { ProgramService } from '../../program.service';

@Component({
    selector: 'app-add-sloturi-blocare',
    templateUrl: './add-sloturi-blocare.component.html',
    styleUrls: ['./add-sloturi-blocare.component.scss']
})
export class AddSloturiBlocareComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;

    form: FormGroup = new FormGroup({
        date_from: new FormControl('', [Validators.required]),
        time_from: new FormControl('', [Validators.required]),
        date_end: new FormControl('', [Validators.required]),
        time_end: new FormControl('', [Validators.required]),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<AddSloturiBlocareComponent>,
        private programService: ProgramService,
        private notificationService: NotificationService,
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    formatDate(date: Date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

    submitForm() {
        this.isLoading = true;

        const { date_from, date_end, time_from, time_end } = this.form.value as any;

        const newSlotBlocare: SlotBlocare = {
            date_from: date_from ? this.formatDate(date_from) : '',
            date_end: date_end ? this.formatDate(date_end) : '',
            time_from,
            time_end,
            program_id: this.data
        };

        this.programService
            .addSlotBlocare(newSlotBlocare)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
